import React from 'react';
import './styling.css';

function QuestionComponent({ question, children, depth = 0 }) {
  // Only apply depth margin on desktop (min-width: 601px)
  const depthStyle = window.innerWidth > 600 ? { marginLeft: depth * 16 } : {};

  return (
    <div className="question-component" style={depthStyle}>
      <span className="question-title">
        {question.Text}
        {question['Required?'] &&
          String(question['Required?']).toLowerCase() === 'yes' && (
            <span style={{ color: '#d32f2f', marginLeft: 4 }}>*</span>
          )}
      </span>
      {children}
    </div>
  );
}

export default QuestionComponent;
